// The screen a route shows before it exists.
//
// Not a 404 and not a blank page. It names the screen, says which work package brings it, and
// points at what IS available now — so the nav can be complete from day one without a dead link
// ever looking like a bug the owner should report.

import { Link } from 'react-router-dom';
import { routeFor } from './routes.js';

export function NotBuilt({ path }: { path: string }) {
  const route = routeFor(path);

  return (
    <div className="notbuilt">
      <h1 className="notbuilt__title">{route?.labelBg ?? 'Екран'}</h1>
      <p className="notbuilt__body">
        Този екран още не е готов. Идва с пакет <strong>{route?.wp ?? '—'}</strong>.
      </p>
      <p className="notbuilt__body">
        Междувременно: <Link to="/leads">Потенциални</Link> · <Link to="/">Днес</Link>
      </p>
    </div>
  );
}
